import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  pure: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  public transform(content: string | null | undefined): string {
    if (!content) {
      return '';
    }

    const match: string[] = content.match(/[\w\W]*<body\s*\w*>([\w\W]*)<\/body>[\w\W]*/);
    if (match) {
      // if the content has a <body> tag, extract and only return the content inside the <body> tag (e.g. for email templates)
      content = this.sanitizer.sanitize(SecurityContext.HTML, match[1]);
    } else {
      // otherwise sanitize the entire content
      content = this.sanitizer.sanitize(SecurityContext.HTML, content);
    }

    return content;
  }
}
